(function () {
  'use strict';

  var selector = '[data-lf-wishlist-count], .lf-wishlist-header__count';
  var observed = new WeakSet();

  function numericCount(value) {
    var count = Number.parseInt(String(value || '').trim(), 10);
    return Number.isFinite(count) && count > 0 ? count : 0;
  }

  function setBadgeCount(badge, count) {
    var safeCount = numericCount(count);
    var value = String(safeCount);
    if ((badge.textContent || '').trim() !== value) badge.textContent = value;
    if (badge.getAttribute('data-wishlist-count-value') !== value) {
      badge.setAttribute('data-wishlist-count-value', value);
    }
    if (badge.getAttribute('data-count') !== value) badge.setAttribute('data-count', value);
    var empty = safeCount === 0;
    if (badge.hidden !== empty) badge.hidden = empty;
    if (badge.getAttribute('aria-hidden') !== String(empty)) {
      badge.setAttribute('aria-hidden', String(empty));
    }
  }

  function syncBadgeFromText(badge) {
    setBadgeCount(badge, badge.textContent);
  }

  function watchBadge(badge) {
    if (observed.has(badge)) return;
    observed.add(badge);
    syncBadgeFromText(badge);
    new MutationObserver(function () {
      syncBadgeFromText(badge);
    }).observe(badge, { childList: true, characterData: true, subtree: true });
  }

  function scan(root) {
    if (!root) return;
    if (root.nodeType === 1 && root.matches && root.matches(selector)) watchBadge(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(watchBadge);
  }

  function setAll(count) {
    document.querySelectorAll(selector).forEach(function (badge) {
      setBadgeCount(badge, count);
      watchBadge(badge);
    });
  }

  function eventCount(detail) {
    if (!detail) return null;
    if (Number.isFinite(Number(detail.count))) return numericCount(detail.count);
    if (Array.isArray(detail.items)) return detail.items.length;
    return null;
  }

  scan(document);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(scan);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('lf:wishlist:change', function (event) {
    var count = eventCount(event.detail);
    if (count !== null) setAll(count);
  });
  document.addEventListener('wishlist:updated', function (event) {
    var count = eventCount(event.detail);
    if (count !== null) setAll(count);
  });
  window.addEventListener('lf:wishlist:sync', function (event) {
    var count = eventCount(event.detail);
    if (count !== null) setAll(count);
  });
})();